import React from "react";
import { Row, Col, Form, Input } from "antd";
import { Link } from "react-router-dom";

// IMAGES
import footerBg from "../../img/Footer_Bg.png";
import logo from "../../img/logo.png";

// ICONS
import {
    FaFacebook,
    FaInstagram,
    FaLinkedinIn,
    FaTwitter,
    FaRegCopyright,
} from "react-icons/fa";

function Footer() {
    const onFinish = (values) => {
        console.log("Success:", values);
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const { TextArea } = Input;

    return (
        <div className="footer">
            <div className="custom-container">
                <Row>
                    <Col xs={{ span: 24 }} md={{ span: 10 }}>
                        <h1>
                            Have an Idea !? Lets bring your wild ideas into
                            awesome reality.
                        </h1>
                        <h4>Contact Us</h4>
                        <Form
                            name="contact"
                            layout="vertical"
                            initialValues={{ remember: true }}
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        >
                            <Row gutter={[12, 12]}>
                                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                    <Form.Item
                                        label="Name"
                                        name="name"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your name !",
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                                <Col xs={{ span: 24 }} md={{ span: 12 }}>
                                    <Form.Item
                                        label="E-mail"
                                        name="email"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Please input your email !",
                                            },
                                        ]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Form.Item
                                label="Message"
                                name="message"
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input your message !",
                                    },
                                ]}
                            >
                                <TextArea rows={4} />
                            </Form.Item>
                            <Form.Item>
                                <button className="hover-e1" htmlType="submit">
                                    <span className="border-left"></span>
                                    <span className="border-right"></span>
                                    <span className="border-top"></span>
                                    <span className="border-bottom"></span>
                                    Send
                                </button>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col xs={{ span: 24 }} md={{ span: 12 }}>
                        <div className="footer__right">
                            <div className="">
                                <div className="footer__logo">
                                    <img src={logo} alt="" />
                                </div>
                                <div className="footer__contact-info">
                                    <p>Email: info@karmaincnepal.com</p>
                                    <p>Phone: +977-9851121892</p>
                                    <p>Office: Kathmandu, Nepal</p>
                                </div>
                                <div className="social__media">
                                    <p>Follow us on:</p>
                                    <div className="">
                                        <a href="">
                                            <FaFacebook />
                                        </a>
                                        <a href="">
                                            <FaInstagram />
                                        </a>
                                        <a href="">
                                            <FaLinkedinIn />
                                        </a>
                                        <a href="">
                                            <FaTwitter />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col xs={{ span: 24 }}>
                        <div className="copy-right">
                            <div className="">
                                <p>&copy; 2020 Karma Inc.</p>
                            </div>
                            <div className="">
                                <Link>Privacy Policy</Link>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div className="footer__bg">
                <img src={footerBg} alt="" />
            </div>
        </div>
    );
}

export default Footer;
